import { ShippingMethod } from "@core/types";
import getEnabledShippingMethods, { filterShippingMethodsByCartTotal } from "./getEnabledShippingMethods";

/**
 * Если доступен только один метод — сразу выбираем его
 
 * Если доступно несколько методов — сортируем по minAmount (от большего к меньшему)
 
 * Выбираем подходящий метод по сумме заказа, если подходящего метода нет — выбираем последний метод (самый дешевый)
 
 * @param {ShippingMethod[]} shippingMethods - массив методов доставки
 * @param {number} cartSubtotalValue - сумма заказа
 * @returns {ShippingMethod | undefined}
*/
export const getApplicableShippingMethod = (
  shippingMethods: ShippingMethod[],
  cartSubtotalValue: number,
): ShippingMethod | undefined => {
  if (!shippingMethods.length) return;

  const enabledMethods = getEnabledShippingMethods(shippingMethods);
  const activeMethods = filterShippingMethodsByCartTotal({
    methods: enabledMethods,
    cartSubtotalValue,
  });

  // Если доступен только один метод — сразу выбираем его
  if (activeMethods.length === 1) {
    return activeMethods[0];
  }

  // Сортируем по minAmount (от большего к меньшему)
  const sortedActiveMethods = activeMethods.sort((a, b) => Number(b.minAmount) - Number(a.minAmount));

  // Выбираем подходящий метод
  const selectedMethod =
    sortedActiveMethods.find((method) => cartSubtotalValue >= Number(method.minAmount)) || sortedActiveMethods.at(-1);

  // console.log({ selectedMethod });

  return selectedMethod;
};
